import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class ReplicationService {
  constructor() {
  }

  public createReplication() {
  }
}
